/** Tailwind `bottom-10` — legacy layout status-bar strip height. */
export const WORKSPACE_LAYOUT_STATUS_BAR_STRIP_BOTTOM_PX = 40;

/** Tailwind `bottom-2` — inset when no status-bar strip is reserved. */
export const WORKSPACE_LAYOUT_CONTENT_BOTTOM_INSET_PX = 8;

/** Portal anchor margin (`m-2`) on selection bar / agent space containers. */
export const WORKSPACE_LAYOUT_PORTAL_ANCHOR_MARGIN_PX = 8;

export const getWorkspaceLayoutPortalAnchorBottomPx = (reservesStatusBarStrip: boolean): number =>
  reservesStatusBarStrip ? WORKSPACE_LAYOUT_STATUS_BAR_STRIP_BOTTOM_PX : WORKSPACE_LAYOUT_CONTENT_BOTTOM_INSET_PX;

export const getWorkspaceLayoutPortalAnchorBottomClearancePx = (reservesStatusBarStrip: boolean): number =>
  getWorkspaceLayoutPortalAnchorBottomPx(reservesStatusBarStrip) + WORKSPACE_LAYOUT_PORTAL_ANCHOR_MARGIN_PX;
